module.exports = __webpack_public_path__ + "static/img/banner.20d8ef4a.png";